import React, { useEffect } from "react";
import { useHistory } from "react-router-dom";
import ContainerFlex from "components/ContainerFlex";
import useApi, { ApiMethod } from "hooks/useApi";
import Endpoints from "services/api/endpoints";
import { showMessage } from "utils/messages";
import { useAppDispatch, useAppSelector } from "redux/app/hooks";
import { cpfUnmask, phoneUnmask } from "utils/mask";
import { RouteNames } from "routes/routes";
import {
  resetLoading,
  setLoading,
  setTitleLoading,
} from "redux/ui/loadings-slice";
import {
  LOCAL_STORE_ITOKEN,
  LOCAL_STORE_TOKEN_BEARER,
} from "../../../constants";

const Proposta: React.FC = () => {
  const history = useHistory();
  const dispatch = useAppDispatch();

  const {
    cliente: { celular, cpf },
  } = useAppSelector((state) => state.cliente);

  const RequestValidateProposal = useApi<any>(
    `${Endpoints.proposta.getValidateProposal.replace(
      "PARAM_CPF",
      cpfUnmask(cpf),
    )}`,
    ApiMethod.GET,
  );

  const RequestIniciaProposta = useApi<any>(
    `${Endpoints.proposta.postInitialProposal}`,
    ApiMethod.POST,
  );

  const RequestSignInGuest = useApi<any>(
    `${Endpoints.usuario.login}`,
    ApiMethod.POST,
  );

  useEffect(() => {
    async function init() {
      dispatch(setLoading(true));
      dispatch(setTitleLoading("Processando informações, um momento..."));
      try {
        const payload = {
          cpf: "visitante",
          senha: "123456",
        };
        const responseLogin = await RequestSignInGuest.callApi(payload);

        if (responseLogin.status >= 200 && responseLogin.status < 300) {
          const { id, token, novoToken } = responseLogin.data;
          localStorage.setItem(LOCAL_STORE_ITOKEN, token);
          localStorage.setItem(LOCAL_STORE_TOKEN_BEARER, novoToken);

          const response = await RequestValidateProposal.callApi();

          const { obterDadosProposta, temPropostaValida, mensagem } =
            response.data;

          if (!obterDadosProposta && !temPropostaValida) {
            dispatch(setTitleLoading("Gravando informações, um momento..."));
            const codeVerification = sessionStorage.getItem(
              "@NovaEra:codeVerification",
            );
            sessionStorage.setItem("@NovaEra:xCode", codeVerification || "");

            const payload = {
              cpf: cpfUnmask(cpf),
              celular: phoneUnmask(celular),
              optinTermoDeUso: true,
              checkWhatsApp: true,
              idUsuario: id,
              origem: "TOTEM",
            };

            const responseInicia = await RequestIniciaProposta.callApi(payload);

            const { mensagem, status } = responseInicia;

            if (status === 200 || status === 201) {
              showMessage(
                "success",
                "Proposta em andamento...",
                "Oba! Proposta em andamento.. Você deve concluir a tua proposta através do link enviado via SMS para o seu celular. Por favor verificar!",
                { timer: 30000 },
              );
            }

            if (status === 404 && mensagem) {
              showMessage("warning", "Atenção", mensagem!, { timer: 30000 });
            }
            if (status === 500 && mensagem) {
              showMessage(
                "warning",
                "Atenção!",
                "Não podemos lhe atender no momento. Tente novamente mais tarde.",
                { timer: 30000 },
              );
            }
          } else if (mensagem) {
            showMessage("warning", "Atenção!", mensagem, { timer: 30000 });
          } else {
            showMessage(
              "warning",
              "Atenção!",
              "Siga com a tua proposta pela Web, App ou por um operador(a) TeuCard.",
              { timer: 30000 },
            );
          }
        }
      } catch (error) {
        console.log(error);
        showMessage(
          "warning",
          "Atenção!",
          "Não podemos lhe atender no momento. Tente novamente mais tarde.",
          { timer: 30000 },
        );
      } finally {
        history.push(RouteNames.HOME);
        dispatch(resetLoading());
      }
    }
    init();
    // Fluxo de processar-uma-vez-e-sair (sempre navega pra HOME no finally):
    // roda intencionalmente só na montagem, com os valores de cpf/celular do
    // momento. Incluir cpf/celular/dispatch/history/Request* arriscaria reenviar
    // a proposta caso algo mude antes do fim do fluxo assíncrono.
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return <ContainerFlex center flex={1} horizontal />;
};

export default Proposta;
